//引入接口文档
import req from '@/utils/req.js'

//用户集合分组新增修改
export function saveUserList(params) {
  return req.post("/biz/user-list-group123",params);
}

//用户集合分组表详情
export function userListDetail(params) {
  return req.get(`/biz/user-list-group/${params}`);
}

//用户集合分组表分页
export function pageUserList(params) {
  return req.get("/biz/user-list-group/page",params);
}

//用户分组明细表分页
export function pageUserDetailList(params) {
  return req.get("/biz/user-list-group-detail/page",params);
}


//集合修改
export function groupEdit(params) {
  return req.put("/biz/user-list-group",params);
}

